import React, { useContext } from 'react';
import { EiqSelect } from 'eiq-storybook';
import { QuestionDropdownDefaultProps, QuestionDropdownPropTypes } from 'src/components/JobDatasheet/propTypes';
import { OptionWithDefinition } from 'src/components/SelectBox';
import JobDatasheetLanguageContext from 'src/components/JobDatasheet/context/JobDatasheetLanguageContext';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

export const QuestionDropdown = ({
  allowSearch,
  errors,
  flash,
  isRectifiedQuestion,
  onChange,
  question: {
    dropdownSettings: { allowMultiSelect, options },
    translations,
  },
  value,
}) => {
  const { selectedLanguage } = useContext(JobDatasheetLanguageContext);

  const getOptionLabel = (option, index) => {
    if (!selectedLanguage) {
      return option.value;
    }

    const labelTranslation = (translations || []).find(c => c.languageId === selectedLanguage)?.options?.[index];

    /**
     * if translation has changed payload to accommodate definition then
     * return labelTranslation?.value if not then
     * return labelTranslation, if this is also not present then
     * return option's value property by default
     */
    return labelTranslation?.value ?
      labelTranslation.value :
      labelTranslation || option.value;
  };

  const getOptionDefinition = (option, index) => {
    if (!selectedLanguage) {
      return option.definition;
    }

    const definitionTranslation = (translations || []).find(c => c.languageId === selectedLanguage)?.options?.[index];

    /**
     * if translation supports definition then
     * return labelTranslation?.definition if not then
     * that means translation's options only contains data for value and not definition
     * therefore return option's definition property by default
     */
    return definitionTranslation?.definition ?
      definitionTranslation.definition :
      option.definition;
  };

  const selectOptions = options.map(v => {
    if (typeof v === 'string' || v instanceof String) {
      return {
        value: v,
        definition: ''
      };
    }
    return v;
  }).map((v, index) => ({
    value: v.value,
    label: getOptionLabel(v, index),
    subText: getOptionDefinition(v, index),
  }));
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';
  const realValue = (value || { value: null })[selectedValueKey] || null;

  const getReturnObject = (e, withMultiSelect) => {
    const returnObject = {
      ...value,
      type: 'dropdown'
    };

    let returnValue;

    if (withMultiSelect) {
      returnValue = e ? e.map(v => v.value) : null;
    }else if(isRectifiedQuestion && !e?.value){
      returnValue = '';
    } else {
        returnValue = e ? e.value : null;
    }

    returnObject[selectedValueKey] = returnValue;

    return returnObject;
  };

  const displaySelectedOptionsDefinition = () => {

    if (allowMultiSelect) {
      return (
        <s.OptionDefinitionContainer>
          {selectOptions
            .filter(v => (realValue || []).indexOf(v.value) !== -1)
            .filter(v => !!v.subText)
            .map((v, i) => <s.QuestionLabel key={i}>{v.value}: {v.subText}</s.QuestionLabel>)
          }
        </s.OptionDefinitionContainer>
      );
    }

    const selectedOption = selectOptions.find(v => v.value === realValue);

    if(selectedOption && selectedOption.subText) {
      return (
        <s.OptionDefinitionContainer>
          <s.QuestionLabel>{selectedOption.value}: {selectedOption.subText}</s.QuestionLabel>
        </s.OptionDefinitionContainer>
      );
    }

    return null;
  };
  
  return (
    <s.QuestionDropdownWrapper>
       <EiqSelect 
        isMulti = {allowMultiSelect} 
        isSearchEnable = {allowSearch}
        isClearable={true}
        onChange={ (_name, option) => {
          onChange(getReturnObject(option, allowMultiSelect));
        }}        
        options={selectOptions}
        optionRenderer={OptionWithDefinition}
        value={
          allowMultiSelect
            ? selectOptions.filter(v => (realValue || []).indexOf(v.value) !== -1)
            : selectOptions.find(v => v.value === realValue) || null
        }
        />
      {displaySelectedOptionsDefinition()}
    </s.QuestionDropdownWrapper>
  );
};

QuestionDropdown.propTypes = QuestionDropdownPropTypes;
QuestionDropdown.defaultProps = QuestionDropdownDefaultProps;
